module.exports = __webpack_public_path__ + "img/13.c50937f0.webp";